module.exports = __webpack_public_path__ + "static/media/csv_bulk_visitors_search.da5fefa1.csv";